import React from 'react';
import ArcheryScorecard from '../components/ArcheryScorecard';

const BCAPage = () => {
  return (
    <div style={{ padding: '20px' }}>
      <ArcheryScorecard />
    </div>
  );
};

export default BCAPage;
